export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
    ColorText: '#D97745',
    primary: false,
    secondary: false,
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#767676',
    ColorText: '#FFFFFF',
    primary: false,
    secondary: false,
  },
  LEAD: {
    Title: 'Lead',
    primary: true,
    secondary: false,
    Color: '#F8EEDC',
    ColorBorder: '#FFFFFF',
    ColorText: '#7E511E',
  },
  DETAILS_NEEDED: {
    Title: 'Details Needed',
    primary: true,
    secondary: false,
    Color: '#EEEDFD',
    ColorBorder: '#FFFFFF',
    ColorSelected: '#9A5DEB',
    ColorText: '#3A3684',
  },
  STALLED: {
    Title: 'Stalled',
    primary: false,
    secondary: true,
    Color: '#FED89B',
    ColorText: '#5D524A',
    ColorBorder: '#FFFFFF',
  },
  CG_SEARCH: {
    Title: 'CG Search Queued',
    primary: true,
    secondary: false,
    Color: '#E8F1FA',
    ColorBorder: '#FFFFFF',
    ColorSelected: '#4D63D9',
    ColorText: '#2D5FA0',
  },
  CG_SEARCH_ACTIVE: {
    Title: 'CG Search Active',
    primary: true,
    secondary: false,
    Color: '#F8EBF0',
    ColorBorder: '#FFFFFF',
    ColorSelected: '#1F7F8A',
    ColorText: '#692A3E',
  },
  CG_PROFILE_SENT: {
    Title: 'CG Profile Sent',
    primary: true,
    secondary: false,
    Color: '#D8F1E7',
    ColorBorder: '#FFFFFF',
    ColorSelected: '#27A6B5',
    ColorText: '#224F42',
  },
  MEET_GREET: {
    Title: 'Meet & Greet Booked',
    primary: true,
    secondary: false,
    Color: '#E1EFCA',
    ColorBorder: '#FFFFFF',
    ColorSelected: '#1E9B55',
    ColorText: '#3C5921',
  },
  CLOSED_LOST: {
    Title: 'Closed Lost',
    primary: false,
    secondary: true,
    Color: '#EBEBEB',
    ColorBorder: '#FFFFFF',
    ColorText: '#555555',
  },
};
